import React, { useState, useEffect } from 'react';
import { api } from '../api';
import hero1 from '../assets/hero1.png';
import hero2 from '../assets/hero2.png';
import hero3 from '../assets/hero3.png';

interface AuthProps {
  onLoginSuccess: (isAdmin: boolean) => void;
}

const Auth: React.FC<AuthProps> = ({ onLoginSuccess }) => {
  const [isRegister, setIsRegister] = useState(false);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [hero1, hero2, hero3];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const endpoint = isRegister ? '/register' : '/login';
      const payload = isRegister ? { username, email, password } : { username, password };
      const data = await api.post(endpoint, payload);

      setMessage(data.message || 'Success!');
      if (!isRegister) {
        localStorage.setItem('access_token', data.access_token);
        onLoginSuccess(data.is_admin);
      }
    } catch (error: any) {
      setMessage(error.message || 'An error occurred.');
    }
  };

  return (
    <div className="auth-split-container">
      <div className="auth-form-side">
        <div style={{ width: '100%', maxWidth: '400px' }}>
          <h1 className="brand-title">SmartPack</h1>
          <p className="brand-subtitle">Gestione intelligente degli asset digitali.</p>

          <div className="card" style={{ padding: '32px' }}>
            <h2 style={{ marginBottom: '24px' }}>{isRegister ? 'Crea Account' : 'Accedi'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Username</label>
                <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
              </div>
              {isRegister && (
                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
              )}
              <div className="form-group">
                <label>Password</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: '10px' }}>
                {isRegister ? 'Registrati' : 'Entra'}
              </button>
            </form>
            {message && <p style={{ color: message.includes('Success') ? 'green' : 'var(--error-color)', textAlign: 'center', marginTop: '16px' }}>{message}</p>}
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button className="btn btn-text" onClick={() => setIsRegister(!isRegister)}>
                {isRegister ? 'Hai già un account? Login' : 'Serve un account? Registrati'}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="auth-carousel-side">
        {images.map((img, index) => (
          <div
            key={index}
            className={`carousel-image ${index === currentImageIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div>
    </div>
  );
};

export default Auth;